<template>
    <li :class="{ 'sidebar-main-title': link.type == 'headtitle', 'sidebar-list': link.type == 'sub' }">

        <div v-if="link.type == 'headtitle'">
            <h4 class="lan-1">{{ $t(link.headTitle1) }}</h4>

        </div>


        <a href="javascript:void(0)" class="sidebar-link sidebar-title" :class="{ 'active': link.active }"
            v-if="link.type == 'sub'" @click="setNavActive(link, index)">
            <vue-feather :type="link.icon"></vue-feather>
            <span class="lan-3" @click="display()">
                {{ $t(link.title) }}
            </span>
            <label :class="'badge badge-' + link.badgeType" v-if="link.badgeType">{{ (link.badgeValue) }}</label>
            <div class="according-menu" v-if="link.children">
                <i :class="[link.active ? 'fa fa-angle-down' : 'fa fa-angle-right']"></i>
            </div>
        </a>

        <router-link :to="link.path" class="sidebar-link sidebar-title" v-if="link.type == 'link'" router-link-exact-active
            exact v-on:click="hidesecondmenu()">
            <vue-feather :type="link.icon" v-if="!link.active"></vue-feather>
            <span>
                {{ $t(link.title) }}
            </span>
            <i class="fa pull-right mt-1 fa fa-angle-right" v-if="link.children"></i>
        </router-link>

        <a :href="link.path" class="sidebar-link sidebar-title" v-if="link.type == 'extLink'"
            @click="setNavActive(link, index)">
            <vue-feather :type="link.icon"></vue-feather>
            <span>
                {{ $t(link.title) }}
            </span>
            <i class="fa pull-right mt-1 fa fa-angle-right" v-if="link.children"></i>
        </a>

        <a :href="link.path" target="_blank" class="sidebar-link sidebar-title" v-if="link.type == 'extTabLink'"
            @click="setNavActive(link, index)">
            <vue-feather :type="link.icon"></vue-feather>
            <span>
                {{ $t(link.title) }}
            </span>
            <i class="fa pull-right mt-1 fa fa-angle-right" v-if="link.children"></i>
        </a>


        <ul class="sidebar-submenu" v-if="link.children" :style="{ display: link.active ? 'block' : 'none' }">
            <navMenuList v-for="(child, index) in link.children" :link="child" :key="child.title + index" />

        </ul>
    </li>
</template>

<script>
import {
    mapState, mapGetters
} from 'vuex'
import navMenuList from './navMenuList.vue';
export default {
    computed: {
        ...mapState({
            menuItems: state => state.menu.data,
            activeoverlay: (state) => state.menu.activeoverlay,
            togglesidebar: (state) => state.menu.togglesidebar,
            width: (state) => state.menu.width,
            height: (state) => state.menu.height,
            margin: (state) => state.menu.margin,
            menuWidth: (state) => state.menu.menuWidth,
            sidebar: state => state.layout.sidebarType,
        }),
        ...mapGetters({
            sidebar: 'layout/sidebar'
        }),
    },
    components: {
        navMenuList
    },
    props: {
        link: Object,
        show: Boolean,
        index: Number
    },
    methods: {

        display() {
            this.$emit('settingsActive')

        },
        setNavActive(item) {
            this.$store.dispatch('menu/setNavActive', item);

        },
        hidesecondmenu() {
            if (window.innerWidth < 991) {
                this.$store.state.menu.activeoverlay = false,
                    this.$store.state.menu.togglesidebar = false;
                this.menuItems.filter(menuItem => {
                    menuItem.active = false;
                });

            }
        },
    },
}
</script>